import showJSDConfirmPayDialog from '@/components/jsdConfirm/jsdConfirmPayDialog';
import { waitOrderDetect, WaitOrderSense } from '@/utils/waitOrderDetect';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import Switch from 'react-switch';
import {
  apiGetAvailableCouponList,
  apiGetBalance,
  apiGetDirectRechargeList,
  apiGetPayTypeConfigList,
  apiGetSecondActivityList,
  apiGetUserInfo,
  apiPreOrder,
  apiSaveWebLog,
  apiUnifiedPay,
} from '../../api';
import AppBar from '../../components/appBar';
import Button from '../../components/button';
import CalcCount from '../../components/calcCount';
import Page from '../../components/page';
import RadioBox from '../../components/radioBox';
import main from '../../main';
import { DefaultPayType, DisplayType, PackageType, PayType } from '../../utils/dict';
import showPayPage from '../../utils/pay';
import { formatNumber, LoadingMask, modelParsePrice, showBottom, showConfirm, showToast } from '../../utils/utils';
import SelectCouponDialog from './selectCouponDialog';
import { apiGetWeChatSignature } from '../../api';
import PayOrderCard from '@/components/payOrderCard';
import OrderAgreement from '@/components/orderAgreement';

export default function PackOrderConfirmPage() {
  const navigate = useNavigate();
  const payTypeRef = useRef<HTMLDivElement>(null);
  const [wxReady, setWxReady] = useState(false);
  // 可选套餐月份数量 从emPack内取出
  const [numberLevel, setNumberLevel] = useState<number[]>([]);
  // 订单数量
  const [count, setCount] = useState(1);
  // 上个页面已选套餐和（本月或下月）
  const { emPack: _emPack, dateType: _dateType }: { emPack: EmPack; dateType: string } = useLocation().state ?? {};
  const [emPack, setEmPack] = useState(_emPack);
  const [dateType, setDateType] = useState(_dateType);
  // 是否需要高亮闪烁
  const [selectPayType, setSelectPayType] = useState<boolean>();
  // 预存列表 如果没有预存会返回首充列表
  const [preMoneyList, setPreMoneyList] = useState<Premoney[]>([]);
  // 已选预存
  const [preMoney, setPreMoney] = useState<Premoney>();
  // 预存列表是否已加载完成
  const [preMoneyListLoaded, setPreMoneyListLoaded] = useState(false);
  const [defaultPayType, setDefaultPayType] = useState(DefaultPayType.all);
  // 设备余额
  const [balance, setBalance] = useState(modelParsePrice(main.currentEm?.cardDetailWalletVo?.availableAmount || 0));
  // 是否有操作密码
  // const [ifPwd, setIfPwd] = useState(false);
  // 余额和操作密码是否加载完成
  const [balanceLoaded, setBalanceLoaded] = useState(false);
  // 可用优惠券列表
  const [couponList, setCouponList] = useState<Coupon[]>([]);
  // 已选优惠券ID列表
  const [coupons, setCoupons] = useState<string[]>([]);
  // 优惠券列表是否加载完成
  const [couponListLoaded, setCouponListLoaded] = useState(false);
  // 充值优惠信息
  // const [payReduction, setPayReduction] = useState<PayReduction>({});
  // 计算后得到的是否余额支付可用
  const [canBalancePay, setCanBalancePay] = useState(false);
  // 支付方式列表
  const [payConfigList, setPayConfigList] = useState<PayTypeConfig[]>([]);
  const [rechargePackageList, setRechargePackageList] = useState<any[]>([]);
  // 支付方式列表是否加载完成
  const [payConfigListLoaded, setPayConfigListLoaded] = useState(false);
  // 已选支付方式
  const [payType, setPayType] = useState<string>(PayType.balance);
  // 使用组合支付
  const [isUnion, setIsUnion] = useState(false);
  // 选择权益包存储权益包id
  const [selectEquity, setSelectEquity] = useState<string[]>([]);
  // 订单信息
  const [orderInfo, setOrderInfo] = useState<OrderInfo>();
  // 权益包信息
  let packJsonList = orderInfo?.cardProductActivityEquityPackJsonList || [];
  const [submitFlag, setsubmitFlag] = useState<boolean>(false);
  const [payOrderCardDialogShow, setPayOrderCardDialogShow] = useState<boolean>(false);
  const [agreementAgreed, setAgreementAgreed] = useState<boolean>(true);
  let isConfirming = false;
  // 停留或后退计时
  const backRef = useRef<{ timer?: NodeJS.Timeout; time: number; isShow: boolean }>({ time: 0, isShow: false });
  useEffect(() => {
    preLoad();
    let _backRef = backRef.current;
    // @ts-ignore
    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', () => setWxReady(true), false);
        // @ts-ignore
      } else if (document.attachEvent) {
        // @ts-ignore
        document.attachEvent('WeixinJSBridgeReady', () => setWxReady(true));
      }
    } else {
      setWxReady(true);
    }
    if (!!emPack.numberLevel) {
      let list: number[] = emPack.numberLevel!.split(',').map((i) => parseInt(i));
      if (list.length) {
        setNumberLevel(list);
        setCount(list[0]);
      }
    }
    wxConfig();
    startBackTimer();
    return () => {
      if (_backRef.timer) {
        clearInterval(_backRef.timer);
      }
    };
  }, []); // eslint-disable-line

  function startBackTimer() {
    if (!backRef.current.timer) {
      backRef.current.timer = setInterval(() => {
        backRef.current.time++;

        if (backRef.current.time >= 60) {
          backRef.current.isShow = true;
          handleLongTimeDialog();
        }
        if (backRef.current.isShow) {
          clearInterval(backRef.current.timer);
        }
      }, 1000);
    }
  }

  async function handleBack() {
    if (backRef.current.isShow) {
      navigate(-1);
    } else {
      let res = await showConfirm({
        title: '提示',
        content: '您是否存在疑问，需要联系客服？',
        cancelBtnText: '返回',
        confirmBtnText: '联系客服',
      });
      if (res === 1) {
        navigate('/customer');
      } else {
        navigate(-1);
      }
    }
  }

  async function handleLongTimeDialog() {
    let res = await showConfirm({
      title: '提示',
      content: '您在该界面停留时间过久，是否存在疑问？',
      hideCancelBtn: true,
      confirmBtnText: '联系客服',
    });
    if (res === 1) {
      navigate('/customer');
    }
  }

  useEffect(() => {
    if (balanceLoaded && preMoneyListLoaded && couponListLoaded) {
      preOrder();
    }
  }, [count, coupons]); // eslint-disable-line
  /**
   *  预加载
   */
  async function preLoad() {
    if (!emPack || !dateType || !main.currentEm?.id) {
      navigate('/home', { replace: true });
      return;
    }
    setEmPack(emPack);
    setDateType(dateType);
    LoadingMask.show('正在处理...');
    await loadPreMoney();
    await loadBalance();
    // await loadPayConfigReduction();
    await loadCouponList();
    await getRechargePackageList();
    LoadingMask.hide();
  }
  async function getRechargePackageList() {
    try {
      let res = await apiGetDirectRechargeList(main.currentEm!.id!);

      let data = res.data;
      if (data.code === 200) {
        let list = (data?.data ?? []).filter((item: any) => item?.showRechargeStatus === 'show');
        // const arr =
        //   list?.filter((item: any) => {
        //     let giveAmount =
        //       Number(item.price ?? 0) >= Number(item.amount ?? 0)
        //         ? Number(item.activityAmount ?? 0) + Number(item.price ?? 0) - Number(item.amount ?? 0)
        //         : 0;
        //     return giveAmount > 0;
        //   }) ?? [];
        const grouped = list?.reduce((acc: any, _: any, i: any, source: any) => {
          if (i % 3 === 0) {
            acc.push(source.slice(i, i + 3));
          }
          return acc;
        }, []);
        setRechargePackageList(grouped ?? []);
      } else {
      }
    } catch (e) { }
  }
  /**
   *  获取预存金额
   */
  async function loadPreMoney() {
    let _list: Premoney[] = [];

    try {
      let res = await apiGetSecondActivityList(main.currentEm?.id!, emPack!.id!);
      let data = res.data;
      if (data.code === 200) {
        setPreMoneyListLoaded(true);
        if (data.data) {
          data.data.forEach((i: any) => {
            _list.push({
              id: i.id,
              amount: parseFloat(i.amount ?? 0),
              payAmount: parseFloat(i.payAmount ?? 0),
              price: parseFloat(i.price ?? 0),
              forceActivity: i.forceActivity === 'Y',
              activityAmount: parseFloat(i.activityAmount ?? 0),
            });
          });
        }
      } else {
        setPreMoneyListLoaded(false);
      }
    } catch (e: any) {
      showToast(e.message || '获取订单信息错误');

      setPreMoneyListLoaded(false);
    }
    setPreMoneyList(_list);
  }
  /**
   * 获取余额
   */
  async function loadBalance() {
    try {
      var res = await apiGetBalance(main.currentEm?.id!);
      var data = res.data;
      if (data.code === 200) {
        // var _data = data['data'];
        let balance = modelParsePrice(data.data.availableAmount);
        // let ifPwd = _data['isPayPassword'] === true;
        setBalance(balance);
        // setIfPwd(ifPwd);
        setBalanceLoaded(true);
        setDefaultPayType(data.data.payType || DefaultPayType.all);
        await loadPayConfigList(data?.data?.payType);
        // else if (data.data.payType && data.data.payType !== 'all') {
        //   if (data.data.payType === DefaultPayType.balance) {
        //     setPayType(PayType.balance);
        //   } else if (data.data.payType === DefaultPayType.wechat) {
        //     setPayType(PayType.wechatJsPay);
        //   } else if (data.data.payType === DefaultPayType.jsd_mini_wx) {
        //     setPayType(PayType.jsd_mini_wx);
        //   }
        // }
      } else {
        setBalanceLoaded(false);
      }
    } catch (e) {
      setBalanceLoaded(false);
    }
  }

  /**
   *  获取可用优惠券列表
   * @param count 订单数量
   */
  async function loadCouponList(_count?: number) {
    try {
      var res = await apiGetAvailableCouponList(main.currentEm?.id!, emPack!.id!, _count ?? count);
      var data = res.data;

      if (data.code === 200) {
        setCouponList(data.data);
        setCoupons(data.data.length ? [data.data[0].id] : []);
        setCouponListLoaded(true);
      } else {
        setCouponListLoaded(false);
      }
    } catch (e) {
      setCouponListLoaded(false);
    }
  }

  // /**
  //  * 获取支付优惠
  //  */
  // async function loadPayConfigReduction() {
  //   try {
  //     let res = await apiGetPayConfigReduction(main.currentEm?.id!);
  //     let data = res.data;
  //     if (data.code === 200) {
  //       let _map: any = {};
  //       (data.data ?? []).forEach((i: any) => (_map[i.payType] = i));
  //       setPayReduction(_map);
  //     }
  //   } catch (e) {}
  // }

  /**
   * 获取支付配置列表
   */
  async function loadPayConfigList(_payType: string) {
    try {
      let res = await apiGetPayTypeConfigList(emPack!.id!);
      let data = res.data;
      if (data.code === 200) {
        let list: PayTypeConfig[] = data.data ?? [];
        setPayConfigList(list);
        setPayConfigListLoaded(true);
        if (_payType === PayType.userSelected) {

          setPayType(PayType.userSelected);
        } else {
          let defaultSelectedItem = (list ?? []).filter((i: PayTypeConfig) => i?.defaultSelected === 'Y');

          setPayType(!!defaultSelectedItem ? defaultSelectedItem[0]?.payType! : '');
        }
      }
    } catch (e) { }
  }

  /**
   *
   * 选择优惠券
   */
  async function handleSelectCoupon() {
    if (!couponList.length) {
      return showToast('暂无可用优惠券');
    }
    let res = await showBottom((onOk) => <SelectCouponDialog onOk={onOk} list={couponList} selects={coupons} />);
    if (!res) return;
    if (res.sort().join('') !== coupons.sort().join('')) {
      setCoupons(res);
    }
  }
  async function wxConfig() {
    // @ts-ignore
    let wx = window.wx;

    let res = await apiGetWeChatSignature(
      main.isIos14 ? main.enterUrl : window.location.href.split('#')[0],
      main.appId,
      main.currentEm?.emNumber
    );
    let data = res.data;
    if (data.code === 200) {
      let _data = data.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: main.appId, // 必填，公众号的唯一标识
        timestamp: _data.timestamp, // 必填，生成签名的时间戳
        nonceStr: _data.nonceStr, // 必填，生成签名的随机串
        signature: _data.signature, // 必填，签名
        jsApiList: [], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'],
      });
      wx.error((err: any) => {
        console.error('❌ wx.config 错误：', err);
        saveWebLog(err.errMsg, _data);
      });
    }
  }
  // 判断是否在微信内
  function isWechatBrowser() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('micromessenger') && !ua.includes('wxwork');
  }
  function saveWebLog(errorMsg: string, data: any) {
    const isWx = isWechatBrowser();
    try {
      apiSaveWebLog({
        businessType: 'wechatErrorLog',
        logParams: {
          ...data,
          isWx: isWx,
          errMsg: errorMsg,
          emNumber: main.currentEm?.emNumber,
          url: main.isIos14 ? main.enterUrl : window.location.href.split('#')[0],
        },
      });
    } catch (error) { }
  }
  /**
   *  预下单
   *
   */
  async function preOrder() {
    LoadingMask.show('正在生成预览...');
    try {
      var res = await apiPreOrder(emPack!.id!, main.currentEm!.id!, coupons, dateType, count);
      let data = res.data;
      if (data.code !== 200) {
        return showToast(data.msg || '接口错误');
      }
      let _orderInfo: OrderInfo = data.data;
      _orderInfo.salePrice = modelParsePrice(_orderInfo.salePrice);
      _orderInfo.orderPrice = modelParsePrice(_orderInfo.orderPrice);
      _orderInfo.realPrice = modelParsePrice(_orderInfo.realPrice);
      _orderInfo.couponPrice = modelParsePrice(_orderInfo.couponPrice);
      let _canBalancePay = balance >= (_orderInfo.orderPrice ?? 0);
      const defaultSelected: string[] = [...selectEquity];
      // const packList: any[] = data.data?.cardProductActivityEquityPackJsonList || [];// 权益包信息
      // if (packList.length) {
      if (_orderInfo?.cardProductActivityEquityPackJsonList?.length) {
        // 6560需求  套餐订购详情页只展示生效类型为 随本期购买的权益包
        // _orderInfo['cardProductActivityEquityPackJsonList'] = packList.filter((i: any) => i?.effectType === 'followCurrent');
        _orderInfo.cardProductActivityEquityPackJsonList.forEach((item) => {
          item.price = modelParsePrice(item.price);
          if (selectEquity.length === 0 && item.defaultSelected === 'Y') {
            defaultSelected.push(item.equityPackageInfoId!);
          }
        })
        setSelectEquity(defaultSelected);
        _canBalancePay = balance >= Number(_orderInfo.realPrice ?? 0) + getEquityPackageTotalPrice(defaultSelected);
      }
      if (!!_orderInfo.activityCardPackDetail) {
        _orderInfo.activityCardPackDetail!.salePrice = modelParsePrice(_orderInfo.activityCardPackDetail!.salePrice);
        _orderInfo.activityCardPackDetail!.activityNumber = modelParsePrice(
          _orderInfo.activityCardPackDetail!.activityNumber
        );
      }

      let _payType = payType;
      let _preMoney: Premoney | undefined = undefined;

      let forceActivity = preMoneyList.some((i) => i.forceActivity === true);
      if (!_canBalancePay && _payType === PayType.balance) {
        _payType = payConfigList.find((i) => i.payType !== PayType.balance)?.payType!;
        if (preMoneyList?.length && forceActivity) {
          _preMoney = preMoneyList[0];
        }
      }

      if (preMoneyList?.length && (_preMoney?.payAmount ?? 0) < (_orderInfo.orderPrice ?? 0)) {
        for (let i of preMoneyList) {
          if (i.payAmount >= (_orderInfo.orderPrice ?? 0)) {
            _preMoney = i;
            break;
          }
        }
      }
      if (!_canBalancePay && (_preMoney?.payAmount ?? 0) < (_orderInfo.orderPrice ?? 0)) {
        // 余额不足时保留续充档位，走强制续充逻辑
      } else if ((_preMoney?.payAmount ?? 0) < (_orderInfo.orderPrice ?? 0)) {
        _preMoney = undefined;
      }
      if (!preMoney && !forceActivity) {
        _preMoney = undefined;
      }
      if (!!preMoneyList.length && _payType !== PayType.balance && selectEquity.length > 0) {
        _preMoney = getRealPayItem();
      }
      setOrderInfo(_orderInfo);
      setCanBalancePay(_canBalancePay);
      if (defaultPayType === DefaultPayType.all) {

        setPayType(_payType);
      }
      setPreMoney(_preMoney);
    } catch (e) {
      console.log(e);
    } finally {
      LoadingMask.hide();
    }
  }
  /**
   * 权益包+套餐金额 → 返回匹配的 强充套餐对象
   * 规则：
   * 1. 小于所有档位 → 返回最小档位
   * 2. 大于等于最大档位 → 返回最大档位
   * 3. 中间 → 返回第一个 >= 总金额的档位
   */
  const getRealPayItem = () => {
    let equityPrice = 0;
    const equityPacks = orderInfo?.cardProductActivityEquityPackJsonList || [];
    const selectEquityPacks = equityPacks.filter((item) => selectEquity.includes(item.equityPackageInfoId!));
    selectEquityPacks.forEach((item) => {
      equityPrice += Number(item?.price ?? 0);
    })
    const orderPrice = Number(orderInfo?.orderPrice || 0);
    // 总金额：套餐 + 权益包
    const payAmount = equityPrice + orderPrice;

    if (!preMoneyList || preMoneyList.length === 0) {
      return undefined;
    }

    const sortedList = [...preMoneyList].sort((a, b) => Number(a.payAmount) - Number(b.payAmount));

    const minItem = sortedList[0];
    const maxItem = sortedList[sortedList.length - 1];
    const minAmount = Number(minItem.payAmount);
    const maxAmount = Number(maxItem.payAmount);

    if (payAmount < minAmount) {
      // 小于最小值
      return minItem;
    } else if (payAmount >= maxAmount) {
      // 大于等于最大值
      return undefined;
    } else {
      // 中间
      return sortedList.find((item) => Number(item.payAmount) >= payAmount);
    }
  };

  async function handlePay() {
    if (submitFlag) return;
    // 先判断是否未选择支付方式（userSelected），触发闪烁提示
    if (payType === PayType.userSelected) {
      setSelectPayType(false);
      showToast('请选择支付方式后进行支付~');
      payTypeRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      requestAnimationFrame(() => {
        setSelectPayType(true);
        setTimeout(() => setSelectPayType(false), 3000);
      });
      return;
    }
    let _payList = (payConfigList ?? []).map((item) => item.payType);
    if (!_payList.includes(payType)) {
      setSelectPayType(false);
      showToast('请选择支付方式后进行支付~');
      payTypeRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      requestAnimationFrame(() => {
        setSelectPayType(true);
        setTimeout(() => setSelectPayType(false), 3000);
      });
      return;
    }
    setsubmitFlag(true);
    try {
      // 判断是否有待支付订单，如果有就关闭订单
      const isPass = await waitOrderDetect({ sense: WaitOrderSense.Pay });
      if (!isPass) return;

      if (!main.openId && !main.isDev) {
        return showToast('授权失败,请在微信内打开');
      }
      if (!balanceLoaded || !preMoneyListLoaded || !couponListLoaded || !payConfigListLoaded) {
        return showToast('获取下单数据错误，请稍后重试');
      }
      // if (
      //   preMoneyList.length &&
      //   payType !== PayType.balance &&
      //   !!preMoney &&
      //   (preMoney?.payAmount ?? 0) < (orderInfo?.realPrice ?? 0)
      // ) {
      //   return showToast('预存费用不能低于套餐金额');
      // }
      if (!canBalancePay && payType === PayType.balance) {
        if (preMoneyList?.length) {
          // 余额不足，走强制续充逻辑：切换支付方式，直接支付+购买套餐
          let _nonBalancePayType = payConfigList.find((i) => i.payType !== PayType.balance)?.payType!;
          setPayType(_nonBalancePayType);
          return;
        } else {
          // 没有续充档位，提示联系客服
          let balanceMsg = await showConfirm({
            title: '提示',
            content: '余额不足，请选择其他支付方式！',
            cancelBtnText: '取消',
            confirmBtnText: '联系客服',
          });
          if (!balanceMsg) return;
          navigate('/customer');
          return;
        }
      }

      // 要支付的金额
      let price =
        (payType === PayType.balance ? orderInfo?.realPrice : preMoney?.payAmount ?? orderInfo?.realPrice) ?? 0;
      if (selectEquity.length > 0) {
        let _price = (price = price + getEquityPackageTotalPrice());
        if (!!preMoneyList.length && payType !== PayType.balance) {
          price = getRealPayAmount();
        } else {
          price = _price;
        }
      }
      if (selectEquity.length === 0) {
        if (isConfirming) return;
        isConfirming = true;
        let confirmRes = await showConfirm({
          title: '提示',
          content: (
            <div className="d-flex-c ai-start font-size-12">
              <div>
                本次消费用<span className="text-color-p">{PayType.typeStr(payType)}</span>支付:{price}元
              </div>
              <div className="text-left">
                <span className="text-color-9">订单名称:</span>
                <span className="text-color-3">{orderInfo?.name}</span>
              </div>
              <div>
                <span className="text-color-9">订单类型:</span>
                <span className="text-color-3">
                  {emPack.packageType === PackageType.basicpackage ? '基础包' : '加油包'}
                </span>
              </div>
              <div>
                <span className="text-color-9">套餐消费:</span>
                <span className="text-color-3">{orderInfo?.realPrice}元</span>
              </div>
              <div>套餐有效期:</div>
              {dateType === 'next' && <div className="text-color-red">请注意,您购买的是下期套餐</div>}
              <div className={`text-color-3 ${dateType === 'next' ? 'text-color-red' : ''}`}>
                {dayjs(orderInfo?.startEffectTime).format('YYYY-MM-DD')}至
                {dayjs(orderInfo?.endEffectTime).format('YYYY-MM-DD')}
              </div>
            </div>
          ),
        }).finally(() => {
          isConfirming = false;
        });
        if (!confirmRes) {
          setsubmitFlag(false);
          return;
        }
        await submitOrderPay();
      } else {
        setPayOrderCardDialogShow(true);
      }
      // let pwd: string = '';
      // if (payType === PayType.balance) {
      //   if (!ifPwd) {
      //     let res = await showConfirm({
      //       title: '提示',
      //       content: '请设置操作密码',
      //       hideCancelBtn: true,
      //       confirmBtnText: '去设置',
      //     });
      //     if (res !== 1) return;
      //     navigate('/set-password');
      //     return;
      //   }
      //   let res = await showBottom((onOk) => <PayPasswordDialog onOk={onOk} price={orderInfo.realPrice} />);
      //   if (!res) return;
      //   pwd = res;
      // }
    } catch (e: any) {
      showToast(e.message ?? '下单失败');
    } finally {
      setsubmitFlag(false);
      LoadingMask.hide();
    }
  }
  async function submitOrderPay() {
    LoadingMask.show('正在提交...');

    var body: any = {
      emId: main.currentEm?.id,
      cardPackDetailId: emPack!.id!,
      equityPackageInfoIds: selectEquity,
      couponCodeIds: coupons,
      dateType: dateType,
      payType: price > 0 ? payType : PayType.balance,
      openId: main.openId,
      appId: main.appId,
      number: count,
      isUnion,
      isEquity: selectEquity.length > 0 ? true : false,
    };
    if (payType === PayType.balance) {
      // body.payPassword = pwd;
    } else {
      body.cardPayDetailId = preMoney?.id;
    }

    try {
      let res = await apiUnifiedPay(body);
      let data = res.data;
      if (data.code === 200) {
        if (payType === PayType.balance || price === 0) {
          paySuccess();
        } else if (
          payType === PayType.aliPage ||
          payType === PayType.jsd_h5_ali ||
          payType === PayType.lkl_ali_pay ||
          payType === PayType.yh_wx_web ||
          payType === PayType.yh_ali_web
        ) {
          // 支付宝支付
          let _data = data.data;
          let payRes = await showPayPage(_data, payType);

          if (payRes.code === 300 || payRes.code === 400) {
            if (payRes.url) {
              LoadingMask.hide();
              window.location.href = payRes.url;
              // await showConfirm({
              //   title: '提示',
              //   content: '是否支付完成?',
              //   confirmBtnText: '支付完成',
              //   cancelBtnText: '未完成',
              // });
              // navigate('/home', { replace: true });
            }
            showToast(payRes.msg);
          } else if (payRes.code === 500) {
            showToast(payRes.msg);
          } else {
            showToast('数据还在准备,请稍后重试');
          }
        } else if (payType === PayType.jsd_mini_wx) {
          // 金舜达 银盛支付 小程序支付  需要弹窗让用户再次点击按钮
          LoadingMask.hide();
          let res = await showJSDConfirmPayDialog({
            miniOrgId: data.data.miniOrgId,
            miniPath: data.data.miniPath,
            miliPaLink: data.data.miniPayLink,
          });
          if (res === 2) {
            showToast('小程序跳转失败');
          } else if (res === 1) {
            let payRes = await showConfirm({
              title: '提示',
              content: '是否支付完成?',
              confirmBtnText: '支付完成',
              cancelBtnText: '未完成',
            });
            if (!payRes) return;
            navigate('/home', { replace: true });
          } else {
            showToast('取消支付');
          }
        } else {
          if (wxReady) {
            let _data = data.data;
            let payRes = await showPayPage(_data, payType);

            if (payRes.code === 200) {
              paySuccess();
            } else if (payRes.code === 300) {
              if (payRes.url) {
                LoadingMask.hide();
                navigate('/iframe', { state: { url: payRes.url, title: '支付', pay: true } });
              }
              showToast(payRes.msg);
            } else if (payRes.code === 400 && !!payRes.url) {
              LoadingMask.hide();
              window.location.href = payRes.url!;
              // let isPayRes = await showConfirm({
              //   title: '提示',
              //   content: '是否支付完成?',
              //   confirmBtnText: '支付完成',
              //   cancelBtnText: '未完成',
              // });
              // if (!isPayRes) return;
              // navigate('/home', { replace: true });
            } else if (payRes.code === 500) {
              showToast(payRes.msg);
            }
          } else {
            showToast('数据还在准备,请稍后重试');
          }
        }
      } else if (data.code === 505) {
        LoadingMask.hide();
        let resMsg = await showConfirm({
          title: '温馨提示',
          content: '检测到您多次未完成支付，请确认订购意向后再进行缴费！',
          confirmBtnText: '联系客服',
          cancelBtnText: '关闭',
        });
        if (!resMsg) return;
        navigate('/customer');
      } else {
        showToast(data.msg ?? '下单失败');
      }
    } catch (error) {
    } finally {
      LoadingMask.hide();
    }
  }

  async function paySuccess() {
    try {
      let res = await apiGetUserInfo(main.loginKey!);
      let data = res.data;

      if (data.code === 200) {
        main.user = data.data.user;
      }
    } catch (e: any) {
      console.error(e);
    } finally {
      navigate('/recharge-success', {
        replace: true,
        state: {
          name: orderInfo?.name,
          type: PackageType.basicpackage ? '基础包' : '加油包',
          startTime: dayjs(orderInfo?.startEffectTime).format('YYYY-MM-DD'),
          endTime: dayjs(orderInfo?.endEffectTime).format('YYYY-MM-DD'),
        },
      });
    }
  }

  function handleLookTips(item: any) {
    showConfirm({
      title: '购买须知',
      content: item.tips,
      hideCancelBtn: true,
      confirmBtnText: '关闭',
    });
  }

  async function handleSelectEquity(item: any) {
    let newSelectEquity: string[] = [];
    if (selectEquity.includes(item.equityPackageInfoId!)) {
      // 取消权益包
      if (selectEquity.length === 1) {
        let res = await showConfirm({
          title: '权益包',
          content: (
            <div className="text-left bw-100">
              <div>是否取消权益包？</div>
              <div>取消权益包您将失去权益包提供的各种权益</div>
            </div>
          ),
          confirmBtnText: '继续购买',
          cancelBtnText: '残忍拒绝',
          maskClose: false,
          cancelClose: false,
        });
        if (res === 1) return;
        newSelectEquity = [];
      } else {
        newSelectEquity = selectEquity.filter((i) => i !== item.equityPackageInfoId!);
      }
    } else {
      // 新增权益包
      newSelectEquity = [...selectEquity];
      newSelectEquity.push(item.equityPackageInfoId!);
    }
    setSelectEquity(newSelectEquity);

    // 计算是否可以余额支付
    let _canBalancePay = balance >= (orderInfo?.realPrice ?? 0);
    if (newSelectEquity.length > 0) {
      _canBalancePay = balance >= (orderInfo?.realPrice ?? 0) + getEquityPackageTotalPrice(newSelectEquity);
    }
    setCanBalancePay(_canBalancePay);
    // 如果可以余额支付 设置为余额支付
    if (_canBalancePay) {

      setPayType(PayType.balance);
    } else if (payType === PayType.balance) {
      // 如果不可余额支付 当前又是余额支付 则设置为其他支付方式

      let _payType = payConfigList.find((i) => i.payType !== PayType.balance)?.payType!;

      if (_payType) {
        setPayType(_payType);
      }
    }
    // 切换选中权益包状态必定关闭组合支付
    setIsUnion(false);
  }
  // 获取选中权益包的金额合计
  function getEquityPackageTotalPrice(newSelectEquity?: string[]) {
    let totalPrice: number = 0;
    const equityPackageInfoIds: string[] = newSelectEquity || selectEquity;
    if (equityPackageInfoIds?.length) {
      const equityPacks = orderInfo?.cardProductActivityEquityPackJsonList || [];
      equityPacks.forEach((i) => {
        if (equityPackageInfoIds.includes(i.equityPackageInfoId!)) {
          totalPrice += Number(i.price);
        }
      });
    }
    return totalPrice;
  }
  function renderEquity() {
    if (!packJsonList?.length) {
      return null;
    }
    return (
      <div className="mt-10 bg-white pt-10 pb-5 pl-20 pr-20">
        <div>权益包</div>
        <div className="mt-10">
          {
            packJsonList.map((item) => (
              <div className="pos-r mb-5">
                <img src={item.img} className="pos-r z-0 bw-100" alt="" onClick={() => handleSelectEquity(item)} />
                <div className="pos-a t-10 r-10 text-right">
                  <RadioBox value={selectEquity.includes(item.equityPackageInfoId!)} onChange={() => handleSelectEquity(item)} />
                  <div className="text-color-9 font-size-12 mt-5" onClick={() => handleLookTips(item)}>
                    购买须知
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    );
  }

  /**
   * 已选套餐包
   * @returns view
   */
  function renderSelectPack() {
    return (
      <div className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20 d-flex-r ai-center">
        <div className="flex-1">
          <div>订单名称：{emPack?.name}</div>
          <div className="mt-10">
            订单类型：{emPack?.packageType === PackageType.basicpackage ? '基础包' : '加油包'}
          </div>
        </div>
        <div className="font-size-18 font-widget-600">￥{emPack?.salePrice}</div>
      </div>
    );
  }
  /**
   * 优惠券
   * @returns view
   */
  function renderCoupon() {
    let selectCoupons: Coupon[] = [];
    if (coupons?.length) {
      selectCoupons = couponList.filter((i) => coupons.includes(i.id!));
    }

    var couponTips = '';

    if (!couponList?.length) {
      couponTips = '暂无可用优惠券';
    } else if (!coupons?.length) {
      couponTips = '有可用优惠券';
    } else if (selectCoupons.length === 1) {
      couponTips = selectCoupons[0].couponName!;
    } else if (selectCoupons.length > 1) {
      couponTips = `组合优惠 - ${orderInfo?.couponPrice ?? 0}`;
    }
    return (
      <div className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20  d-flex-r ai-center" onClick={handleSelectCoupon}>
        <div className="flex-1">优惠券</div>
        <div className={`${couponList.length > 0 ? 'text-color-red' : 'text-color-9'} font-size-12 mr-10`}>
          {couponTips}
        </div>
        <img className="icon-12" src="/pic/icon_arrow_right.png" alt="" />
      </div>
    );
  }

  /**
   * 购买数量
   * @returns view
   */
  function renderCount() {
    return (
      <div className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20">
        <div className="d-flex-r">
          <div className="flex-1">购买数量</div>
          <CalcCount
            min={1}
            number={count}
            onChange={(value) => setCount(value)}
            max={!!emPack?.buyLimit ? emPack?.buyLimit : 99}
          />
        </div>
        <div className="font-size-12 text-color-red mt-10">
          套餐有效期:{orderInfo?.startEffectTime ? dayjs(orderInfo.startEffectTime).format('YYYY-MM-DD') : '-'}至
          {orderInfo?.endEffectTime ? dayjs(orderInfo.endEffectTime).format('YYYY-MM-DD') : '-'}
          <span className="ml-10">
            共 <span className="text-color-red">{orderInfo?.packPeriodTotalNum}</span> 期
          </span>
        </div>
      </div>
    );
  }
  /**
   * 赠送套餐
   * @returns view
   */
  function sendPackage() {
    return (
      <div className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20 ">
        <div className="font-size-14">赠送套餐</div>
        <div className="d-flex-r ai-center">
          <div className="flex-1 d-flex-c font-size-12">
            <div className="mt-10 pl-10">套餐名称：{orderInfo?.activityCardPackDetail?.name}</div>
            <div className="mt-10 pl-10">赠送数量：{orderInfo?.activityCardPackDetail?.activityNumber}</div>
          </div>
          <div className="text-right">
            <div className="font-widget-600 font-size-18 text-color-9">
              <span className="font-size-14">现价</span>:0
            </div>
            <div className="font-size-12  text-deleteline">¥{orderInfo?.activityCardPackDetail?.salePrice}</div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * 可选套餐数量
   */
  function renderNumberLevel() {
    return (
      <div className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20">
        <div>购买数量</div>
        <div className="d-flex-r mt-10 flex-wrap">
          {numberLevel.map((item) => {
            let active = count === item;
            return (
              <div
                key={item}
                className={`w-100 h-40 line-height-40 d-flex-r ai-center jc-center mb-10 mr-10 border border-radius-8 ${active ? 'border-color-p text-color-p' : 'border-color-gray'
                  }`}
                onClick={() => setCount(item)}
              >
                <div className="d-flex-r ai-baseline">
                  <span className="font-size-20">{item}</span>
                  <span className="font-size-12">个月</span>
                </div>
              </div>
            );
          })}
        </div>
        <div className="font-size-12 text-color-red mt-10">
          套餐有效期:{orderInfo?.startEffectTime ? dayjs(orderInfo.startEffectTime).format('YYYY-MM-DD') : '-'}至
          {orderInfo?.endEffectTime ? dayjs(orderInfo.endEffectTime).format('YYYY-MM-DD') : '-'}
          <span className="ml-10">
            共 <span className="text-color-red">{orderInfo?.packPeriodTotalNum}</span> 期
          </span>
        </div>
      </div>
    );
  }

  /**
   * 订单明细
   * @returns view
   */
  function renderOrderInfo() {
    return (
      <div className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20">
        <div>订单明细</div>
        <div className="d-flex-r ai-center pl-20 mt-20">
          <div className="font-size-12">商品总价：</div>
          <div className="pl-20">￥{orderInfo?.salePrice}</div>
        </div>
        <div className="d-flex-r ai-center pl-20 mt-20">
          <div className="font-size-12">优惠金额：</div>
          <div className="pl-20">￥{orderInfo?.couponPrice}</div>
        </div>
        <div className="d-flex-r ai-center pl-20 mt-20">
          <div className="font-size-12">商品合计：</div>
          <div className="pl-20">￥{orderInfo?.realPrice}</div>
        </div>
      </div>
    );
  }
  const settings = {
    dots: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // 自动滚动
    autoplaySpeed: 4000,
  };
  /**
   * 预存
   */
  function renderPreMoney() {
    if (!preMoneyList?.length) {
      return <div></div>;
    }
    return (
      <div className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20">
        <div>
          充值金额<span className="font-size-12 text-color-9 ml-10">*套餐费用从充值金额扣除</span>
        </div>
        <div className="d-flex-r mt-10 flex-wrap jc-start ai-center" style={{ gap: '10px' }}>
          {preMoneyList.map((item) => {
            var orderPrice = orderInfo?.orderPrice || 0;
            // 权益包金额选择
            let payPrice = getEquityPackageTotalPrice() + Number(orderPrice)
            let disabled = payType === PayType.balance || item.payAmount < payPrice;
            let active = payType !== PayType.balance && preMoney && item.id === preMoney?.id;
            // 到账金额
            let getAmount = Number(item.amount ?? 0) + Number(item.activityAmount ?? 0);
            // 赠送金额
            let giveAmount =
              Number(item.payAmount ?? 0) >= Number(item.amount ?? 0)
                ? Number(item.activityAmount ?? 0) + Number(item.amount ?? 0) - Number(item.payAmount ?? 0)
                : 0;

            // 充值金额
            let rechargeAmount = Number(item.payAmount ?? 0);
            return (
              <div
                className={` d-flex-c ai-center jc-center w-100 h-70 bg-gray pos-r border  border-radius-8 ${active ? 'border-color-origin-red bg-origin-red-t' : disabled ? 'bg-gray border-color-gray' : ''
                  }`}
                key={item.payDetailId}
                onClick={() => {
                  if (disabled) {
                    return;
                  }
                  setPreMoney(item);
                }}
              >
                {/* 充 amount 得 price */}
                <div className=" text-color-origin-red">
                  <span>到账</span>
                  <span className="font-size-18">{formatNumber(getAmount)}</span>元
                </div>
                {getAmount > 0 && <div className="font-size-12 mt-3">赠送{formatNumber(giveAmount)}</div>}
                <div className="mt-3">售价:{formatNumber(rechargeAmount)}元</div>
                {modelParsePrice(item?.price ?? 0) > modelParsePrice(item?.amount ?? 0) && (
                  <img src="/pic/icon_preferential.png" className="icon-26 pos-a r-0 t-0" alt="" />
                )}
              </div>
            );

            // return (
            //   <div
            //     key={item.id}
            //     className={`pos-r w-100 h-70 d-flex-c ai-center jc-center text-center mb-10 mr-10 border border-radius-8 ${
            //       disabled
            //         ? 'bg-gray border-color-gray'
            //         : active
            //         ? 'border-color-p bg-primary-t1'
            //         : 'bg-primary-t1 border-color-p-t1'
            //     }`}
            //     onClick={() => {
            //       if (disabled) {
            //         if (!forceActivity) {
            //           setPreMoney(undefined);
            //         }
            //         return;
            //       }
            //       if (forceActivity) {
            //         setPreMoney(item);
            //       } else {
            //         if (preMoney?.id === item.id) {
            //           setPreMoney(undefined);
            //         } else {
            //           setPreMoney(item);
            //         }
            //       }
            //     }}
            //   >
            //     <div className="font-size-12">
            //       <span className="font-size-18 font-widget-600">{item.payAmount}</span>元
            //     </div>
            //     <div className="font-size-12 text-color-p mt-5">到账{item.amount + item.activityAmount}元</div>
            //     {item.amount > item.payAmount && (
            //       <img className="pos-a z-10 r-0 t-0 w-36" src="/pic/icon_coupon_flag.png" alt="" />
            //     )}
            //   </div>
            // );
          })}
        </div>
      </div>
    );
  }

  /**
   * 支付方式
   */
  function renderPayType() {
    // 过滤充值卡片：到账金额 < 商品合计价格的不展示
    const filteredRechargePackageList = rechargePackageList
      .map((group: any) =>
        group.filter((children: any) => {
          let getAmount = Number(children.price ?? 0) + Number(children.activityAmount ?? 0);
          return getAmount >= (orderInfo?.realPrice ?? 0);
        })
      )
      .filter((group: any) => group.length > 0);

    return (
      <div className="mt-10 bg-white pt-5">
        <div
          ref={payTypeRef}
          className="pt-5 pb-10 pl-5 pr-5 ml-15 mr-15"
          style={{
            border: '2px solid transparent',
            borderRadius: '4px',
            ...(selectPayType ? { animation: 'flashBorderPay 0.5s 3 forwards' } : {}),
          }}
        >
          <style>{`
            @keyframes flashBorderPay {
              0% { border-color: transparent; }
              50% { border-color: #f53f3f; }
              100% { border-color: transparent; }
            }
          `}</style>
          <div>请选择支付方式</div>
          {payConfigList.map((item, idx) => {
            // 权益包金额
            const packageMoney = getEquityPackageTotalPrice();
            let subLabel = item.payType === PayType.balance ? `(账户余额￥${balance})` : '';
            // 有宣传语就显示，没有就不显示
            if (item.slogan && item.payType !== PayType.balance) {
              subLabel = `(${item.slogan})`;
            }
            // 是否使用开关
            let useSwitch = false;
            // 本条支付是余额支付 可以组合支付 又没有首充续充
            if (item.payType === PayType.balance && orderInfo?.isUnion && !preMoneyList?.length) {
              // 有余额但不够支付 单选框变成开关
              if (balance > 0 && balance < orderInfo.realPrice) {
                useSwitch = true;
              } else if (balance > 0 && balance < orderInfo.realPrice + packageMoney) {
                useSwitch = true;
              }
            }
            return (
              <>
                <div
                  key={idx}
                  className="pl-20 mt-20 d-flex-r ai-center"
                  onClick={() => {
                    if (useSwitch) {
                      setIsUnion(!isUnion);
                    } else {

                      setPayType(item.payType!);
                    }
                    if (!!preMoneyList.length && item.payType !== PayType.balance && selectEquity) {
                      let _preMoney = getRealPayItem();
                      console.log('更换支付方式：', _preMoney);
                      setPreMoney(_preMoney);
                    }
                  }}
                >
                  <div className="flex-1 d-flex-r ai-center jc-between">
                    <div className="d-flex-r ai-center">
                      <img className="icon-20 mr-10" src={`/pic/${PayType.typeIcon(item.payType)}`} alt="" />
                      <span className="font-size-12">{item.name || PayType.typeStr(item.payType)}</span>
                      <span
                        className={`ml-10 font-size-12 text-color-${item.payType === PayType.balance ? '9' : 'red'}`}
                        onClick={(e) => {
                          if (item.payType === PayType.balance) {
                            navigate('/recharge');
                          }
                        }}
                      >
                        {subLabel}
                      </span>
                      {useSwitch && (
                        <span className="font-size-12 text-color-9 mr-2">
                          {isUnion ? `支付¥${balance}` : '需组合支付'}
                        </span>
                      )}
                      {isUnion && item.payType === payType && (
                        <span className="font-size-12 text-color-9 mr-2">
                          支付¥
                          {formatNumber((orderInfo?.realPrice ?? 0) + packageMoney - balance)}
                        </span>
                      )}
                    </div>
                    {useSwitch ? (
                      <Switch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor="#6571ff"
                        offColor="#ccc"
                        width={40}
                        height={24}
                        checked={isUnion}
                        onChange={() => setIsUnion(!isUnion)}
                      />
                    ) : (
                      <RadioBox
                        value={item.payType === payType}
                      // disabled={item.payType === PayType.balance && !canBalancePay && !isUnion}
                      />
                    )}
                  </div>
                  <div className="w-50"></div>
                </div>
                {preMoneyList?.length <= 0 && !!filteredRechargePackageList.length && item.payType === PayType.balance && (
                  <div className="mt-10">
                    <Slider
                      {...settings}
                      infinite={filteredRechargePackageList.length <= 1 ? false : true}
                      className="bw-100 custom-swiper"
                    >
                      {filteredRechargePackageList?.map((item: any) => {
                        return (
                          <div className="d-flex ai-center jc-start bw-100 h-80 p-10 mt-10">
                            {item.map((children: any) => {
                              // 到账金额
                              let getAmount = Number(children.price ?? 0) + Number(children.activityAmount ?? 0);
                              // 赠送金额
                              let giveAmount =
                                Number(children.price ?? 0) >= Number(children.amount ?? 0)
                                  ? Number(children.activityAmount ?? 0) +
                                  Number(children.price ?? 0) -
                                  Number(children.amount ?? 0)
                                  : 0;
                              // 充值金额
                              let rechargeAmount = Number(children.amount ?? 0);
                              let isActive = preMoney?.payDetailId === children.payDetailId;
                              return (
                                <div
                                  className={`d-flex-c ai-center jc-center w-110 mb-20 h-70 mr-10 pos-r border border-radius-8 ${
                                    isActive ? 'border-color-p bg-primary-t1' : 'bg-gray'
                                  }`}
                                  key={children.payDetailId}
                                  onClick={() => {
                                    if (isActive) {
                                      setPreMoney(undefined);
                                      setPayType(PayType.balance);
                                    } else {
                                      let _nonBalancePayType = payConfigList.find((i) => i.payType !== PayType.balance)?.payType!;
                                      setPayType(_nonBalancePayType);
                                      setPreMoney({
                                        id: children.payDetailId,
                                        payDetailId: children.payDetailId,
                                        amount: children.amount ?? 0,
                                        payAmount: children.price ?? 0,
                                        price: children.price ?? 0,
                                        forceActivity: false,
                                        activityAmount: children.activityAmount ?? 0,
                                      });
                                    }
                                  }}
                                >
                                  {/* 充 amount 得 price */}
                                  <div className=" text-color-origin-red">
                                    <span>到账</span>
                                    <span className="font-size-18">{formatNumber(getAmount)}</span>元
                                  </div>
                                  {getAmount > 0 && (
                                    <div className="font-size-12 mt-3">赠送{formatNumber(giveAmount)}</div>
                                  )}
                                  <div className="mt-3">售价:{formatNumber(rechargeAmount)}元</div>
                                  {modelParsePrice(children?.price ?? 0) > modelParsePrice(children?.amount ?? 0) && (
                                    <img src="/pic/icon_preferential.png" className="icon-26 pos-a r-0 t-0" alt="" />
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                )}
              </>
            );
          })}
        </div>
      </div>
    );
  }
  /**
   * 权益包+套餐金额
   *  - 小于强冲数据中的支付金额 → 展示【最低强冲金额】
   *  - 大于等于强冲金额 → 展示【套餐+权益包金额】
   */
  const getRealPayAmount = () => {
    // 权益包金额
    const packageMoney = getEquityPackageTotalPrice();
    // 权益包+套餐金额
    let payAmount = packageMoney + Number(orderInfo?.orderPrice || 0);

    // 强冲数据（提取金额 + 排序）
    let sortedPreMoney = preMoneyList
      .map((item) => Number(item.payAmount))
      .filter(Boolean)
      .sort((a, b) => a - b);

    // 找到 >= 总金额的最小档位
    let targetPreMoney = sortedPreMoney.find((item) => item >= payAmount);

    // 最终显示金额 可以手动选择充值金额
    return preMoney ? preMoney.payAmount : targetPreMoney ?? payAmount;
  };

  let price = (payType === PayType.balance ? orderInfo?.realPrice : preMoney?.payAmount ?? orderInfo?.realPrice) ?? 0;

  if (selectEquity.length > 0) {
    let _price = (price = price + getEquityPackageTotalPrice());
    if (!!preMoneyList.length && payType !== PayType.balance) {
      price = getRealPayAmount();
    } else {
      price = _price;
    }
  }
  if (isUnion) {
    price -= balance;
  }
  return (
    <Page
      className="d-flex-c bg-gray"
      contentClassName="flex-1 h-1 d-flex-c"
      appBar={<AppBar title="支付订单" onBack={handleBack}></AppBar>}
    >
      <div className="flex-1 overflow-y">

        {renderSelectPack()}
        {!!orderInfo?.activityCardPackDetail && sendPackage()}
        {renderCoupon()}
        {!!numberLevel.length ? renderNumberLevel() : renderCount()}
        {renderOrderInfo()}
        {renderEquity()}
        {renderPreMoney()}
        {renderPayType()}
        <OrderAgreement onAgreeChange={(v) => setAgreementAgreed(v)} enableOtherProblem />
      </div>
      <div className="pt-10 pb-10 pl-20 pr-20 bg-white">
        <Button
          type={submitFlag || !agreementAgreed ? 'gray' : 'primary'}
          size="md"
          disabled={main?.ispreview}
          long
          onClick={() => {
            if (!agreementAgreed) {
              showToast('请勾选订购须知后，可订购~');
              return;
            }
            handlePay();
          }}
        >
          确认支付￥{formatNumber(price)}
          {selectEquity.length > 0 && <span className="font-size-12 ml-5 text-color-origin">(含权益费)</span>}
        </Button>
      </div>
      {/* onBenefitChange={() => handleSelectEquity()} */}
      {payOrderCardDialogShow && (
        <PayOrderCard
          order={orderInfo!}
          emPack={emPack!}
          selectEquity={selectEquity}
          price={price}
          onBuy={(v) => {
            setPayOrderCardDialogShow(false);
            if (v) submitOrderPay();
          }}
        />
      )}
    </Page>
  );
}
